import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from 'grommet/components/Box'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'

import Footer from '../components/Footer'
import Header from '../components/Header'
import Section from '../components/Section'

import '../styles/SidebarPage.css'

class SidebarPage extends Component {
  render () {
    const {
      title,
      subtitle,
      sections
    } = this.props.data

    return (
      <div className='SidebarPage'>
        <Header />

        <Box align='center'>
          <Heading align='center' margin='none'>{title}</Heading>
          <Paragraph align='center' size='large'>{subtitle}</Paragraph>
        </Box>

        <div className='flex-container'>
          <div className='sidebar'>
            <Section section={sections[0]} history={this.props.history} />
          </div>

          <div className='content'>
            <Section section={sections[1]} history={this.props.history} />
          </div>
        </div>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }
}

SidebarPage.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default SidebarPage



// WEBPACK FOOTER //
// ./src/layouts/SidebarPage.js